import { AppConstants } from "../config/appConstants";

export class CountryCheckHelper {
  static ifUnitedStates = (bankCountryId, bankCountries) => {
    const selectedCountryId = bankCountryId;
    if (!selectedCountryId) return false;

    const selectedCountry = bankCountries.find(
      (country) => country?.id === selectedCountryId
    );
    if (selectedCountry && selectedCountry?.name) {
      return selectedCountry.name === AppConstants.unitedStates;
    }

    return false;
  };

  /**
   * Returns true when the investor's bank country is Australia.
   * Australia does not use IBAN; Account number + SWIFT/BIC are used instead.
   * @param {number|object} bankCountryIdOrObject - Country id (when bankCountries provided) or country object { id, name }
   * @param {Array} [bankCountries] - Optional list of countries when first arg is id
   */
  static ifAustralia = (bankCountryIdOrObject, bankCountries) => {
    if (bankCountries && bankCountries.length > 0) {
      const selectedCountry = bankCountries.find(
        (c) => c?.id === bankCountryIdOrObject
      );
      return selectedCountry?.name === AppConstants.australia;
    }
    if (bankCountryIdOrObject && typeof bankCountryIdOrObject === "object" && bankCountryIdOrObject.name) {
      return bankCountryIdOrObject.name === AppConstants.australia;
    }
    return false;
  };
}
